export default theme => ({
  container: {
    backgroundColor: theme.palette.common.white,
    width: '100%',
    color: theme.palette.grey.main,
    textAlign: 'center',
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  title: {
    marginBottom: theme.spacing(3),
  },
  wrapperContainer: {
    width: '100%',
    '& > *': {
      margin: '0 auto',
    },
  },
  image: {
    width: '100%',
    maxWidth: '122vh',
    objectFit: 'contain',
    verticalAlign: 'middle',
    maxHeight: '85vh',
  },
  toolsContainer: {
    marginTop: theme.spacing(2),
  },
});
